export const QUERY_CACHE_KEY = 'pplx-query-cache';
//# sourceMappingURL=consts.js.map